import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./datepicker.css";
import { CalendarYellow } from "../../../assets/icons";
import styled from "styled-components";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import Icon from "../../Calendar/Icon";
import { WEEK_INDEX } from "../../../constants";

const DatePicker = ({ date, onDateDataChange, promoData }) => {
  const [open, setOpen] = useState(false);
  const handleDateChange = (e) => {
    onDateDataChange(e);
    setOpen(false);
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const filterDates = (day) => {
    if (
      promoData?.outlet?.bookingWeekDays &&
      promoData?.outlet?.bookingWeekDays?.length > 0
    ) {
      let dayString = WEEK_INDEX[day];
      return promoData?.outlet.bookingWeekDays.indexOf(dayString) < 0;
    } else {
      return false;
    }
  };

  const getDisabledDate = (date) => {
    if (
      dayjs(date).format("DD/MM/YYYY") === "18/12/2023" ||
      dayjs(date).format("DD/MM/YYYY") === "31/12/2023" ||
      filterDates(Number(dayjs(date).format("d")))
    ) {
      return true;
    }
  };

  return (
    <CalendarContainer ref={wrapperRef}>
      {open && (
        <CalendarWrapper>
          <Calendar
            maxDate={new Date(promoData.endDate)}
            tileDisabled={({ date, view }) => getDisabledDate(date)}
            minDate={new Date()}
            onChange={(e) =>
              handleDateChange({ target: { value: e, name: "date" } })
            }
            value={date}
          />
        </CalendarWrapper>
      )}
      <StyledInput onClick={() => setOpen(!open)}>
        {date ? dayjs(date).format("MMMM D, YYYY") : "Select Visit Date"}
        <Icon />
      </StyledInput>
    </CalendarContainer>
  );
};

const CalendarContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`;
const CalendarWrapper = styled.div`
  position: absolute;
  bottom: 3.5rem;
`;
const StyledInput = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-position: calc(100% - 0.625rem);
  margin-top: 0.5rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: 0.0625rem solid #ffd029;
  border-radius: 0.25rem;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: 2.75rem;
  font-family: "Poppins";
  font-size: 0.9rem;
  color: white;
  box-sizing: border-box;
  ::placeholder {
    font-family: "Poppins-Book";
    font-size: 1rem;
    color: lightgrey;
  }
`;

export default DatePicker;
